/*
  Copyright 2018 Google LLC

  Use of this source code is governed by an MIT-style
  license that can be found in the LICENSE file or at
  https://opensource.org/licenses/MIT.
*/

import {CacheExpiration} from './CacheExpiration.mjs';
import {Plugin} from './Plugin.mjs';
import './_version.mjs';


/**
 * @namespace workbox.expiration
 */

export {
  CacheExpiration,
  Plugin,
};
